const getClosestOffices = (currentOffice, offices) =>
  offices.reduce((acc, office) => {
    if (office.address) {
      const deltaX = office.address.longitude - currentOffice.address.longitude;
      const deltaY = office.address.latitude - currentOffice.address.latitude;
      const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2);
      if (distance === 0) return acc;

      if (acc.length < 3) {
        return [...acc, { ...office, distanceToCurrent: distance }];
      }

      const place = acc.findIndex(el => distance < el.distanceToCurrent);

      if (place !== -1) {
        const firstPart = acc.slice(0, place);
        const secondPart = acc.slice(place, acc.length - 1);

        return [
          ...firstPart,
          { ...office, distanceToCurrent: distance },
          ...secondPart,
        ];
      }
    }

    return acc;
  }, []);

export default getClosestOffices;
